/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import {
  ItemListWidget,
  IItemListProps,
} from '@/widgets/item-list-mercury-widget-react';

type IUserListCompProps = IItemListProps;

export const UsersItemListComp = (props: IUserListCompProps) => {
  return (
    <>
      {/* <UsersListTable {...(props || {})} />
       */}
      <ItemListWidget type="icon" {...props} />
    </>
  );
};

UsersItemListComp.defaultProps = {};
